//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../Display/Display.GridBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"Associative",1,0],[0,"LabelReference",1,0],[0,"LocalOrigin",1,0],[0,"SectionCurveSettings",0,"Display.SectionCurveSettingsBuilder",0],[0,"ShowLabel",1,0]],[[["point1","point2","point3","point4"],"GetCornerPoints",{R_:{validCornerPoints:''}},0,0],[["point1","point2","point3","point4"],"SetCornerPoints",{R_:{validCornerPoints:''}},4,0],[["groupName"],"SaveCurves",{},1,0]],[]];
SPLM.Display.BoundedGridBuilder = class extends SPLM.Display.GridBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.BoundedGridBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.BoundedGridBuilder.ShowLabelType = Object.freeze({
    "Always" : "Always", "ParalleltoView" : "ParalleltoView", "None" : "None"});

SPLM.Display.BoundedGridBuilder.LabelReferenceType = Object.freeze({
    "Local" : "Local", "Wcs" : "Wcs", "Absolute" : "Absolute"});

export default SPLM;